import React, { useState, useEffect, useContext } from 'react';
import { TextField, Button, Typography } from '@mui/material';
import ErrorDialog from '../ErrorDialog';
import { useNavigate, useParams } from 'react-router-dom';
import { AuthContext } from '../AuthContextProvider';
import { rpc } from '../utils/RpcUtils';
import '../App.css';

const Group = () => {
  const [name, setName] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [description, setDescription] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [openErrorDialog, setOpenErrorDialog] = useState(false);
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const { id } = useParams();

  useEffect(() => {
    const onFetchSuccess = (group) => {
      setName(group.name);
      setDisplayName(group.displayName);
      setDescription(group.description);
    };

    const fetchGroup = async (id) => {
      const params = {
        _id: id,
      };
      rpc({
        method: 'GetEventGroup',
        params,
        setErrorMessage,
        setOpenErrorDialog,
        onSuccess: onFetchSuccess
      });
    };
    if (id) {
      fetchGroup(id);
    }
  }, [id]);

  const onSuccess = () => {
    navigate('/groups');
  };

  const createGroup = async () => {
    if (name === '' || displayName === '' || description === '') {
      setErrorMessage('All fields are required');
      setOpenErrorDialog(true);
      return;
    }
    const params = {
      _site: user._site._id,
      name,
      displayName,
      description,
    };
    rpc({
      method: 'CreateEventGroup',
      params,
      setErrorMessage,
      setOpenErrorDialog,
      onSuccess
    });
  };

  const updateGroup = async () => {
    if (name === '' || displayName === '' || description === '') {
      setErrorMessage('All fields are required');
      setOpenErrorDialog(true);
      return;
    }
    const params = {
      _id: id,
      name,
      displayName,
      description,
    };
    rpc({
      method: 'UpdateEventGroup',
      params,
      setErrorMessage,
      setOpenErrorDialog,
      onSuccess
    });
  };

  const deleteGroup = async () => {
    const params = {
      _id: id,
    };
    rpc({
      method: 'DeleteEventGroup',
      params,
      setErrorMessage,
      setOpenErrorDialog,
      onSuccess
    });
  };

  const handleClose = () => {
    setOpenErrorDialog(false);
  };

  const getButtons = () => {
    if (id) {
      return (
        <div className="HorizontalContainer">
          <Button className="Button" variant="contained"  onClick={updateGroup}>
            Update
          </Button>
          <Button className="Button" variant="outlined" color="error" onClick={deleteGroup}>
            Delete
          </Button>
        </div>
      );
    } else {
      return (
        <Button className="Button" variant="contained" color="primary" onClick={createGroup}>
          Create
        </Button>
      );
    }
  };

  return (
    <div className="GroupDetails">
      <Typography variant="h6" gutterBottom>
        Group {displayName !== null ? `${displayName}` : ''}
      </Typography>
      <TextField className="TextField"
        label="Name"
        value={name}
        onChange={(e) => setName(e.target.value)}
      />
      <TextField className="TextField"
        label="Display Name"
        value={displayName}
        onChange={(e) => setDisplayName(e.target.value)}
      />
      <TextField className="TextField"
        label="Description"
        value={description}
        onChange={(e) => setDescription(e.target.value)}
      />
      {getButtons()}
      <ErrorDialog open={openErrorDialog} onErrorDialogClose={handleClose} errorMessage={errorMessage} />
    </div>
  );
};

export default Group;
